const severityColor = {
  warning: '#FFD58A',
  error: '#F47878',
  info: '#5ACCB9',
  debug: '#88B3E0',
};

export const printError = (error, user, tags, extras) => {
  const color = severityColor.error;

  console.error(`%c [Sentry error] ${error.message}`, `color: ${color}; font-weight: bold`, error);
  // eslint-disable-next-line no-console
  console.info(
    `%c [Sentry error context] User: ${JSON.stringify(user)}, Tags: ${JSON.stringify(tags)}, Extras: ${JSON.stringify(extras)}`,
    `color: ${color}`,
  );
};

export const printMessage = (message, severity, user, tags, extras) => {
  if (severity === 'error') {
    printError({ message }, user, tags, extras);
  }
  if (!Object.keys(severityColor).includes(severity)) {
    // eslint-disable-next-line no-param-reassign
    severity = 'debug';
  }
  // eslint-disable-next-line no-console
  console.info(`%c [Sentry message] ${message}`, `color: ${severityColor[severity]}`);
  // eslint-disable-next-line no-console
  console.info(
    `%c [Sentry message context] User: ${JSON.stringify(user)}, Tags: ${JSON.stringify(tags)}, Extras: ${JSON.stringify(extras)}`,
    `color: ${severityColor[severity]}`,
  );
};
